<template>
  <el-form ref="form" :model="form" :inline="true" style="margin-bottom: -18px;" size="mini">
    <el-form-item>
      <el-button style="float: left" type="primary" @click="query">
        <d2-icon name="search" />查询
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  props: {
    params: {
      default: null,
      type: Object
    }
  },
  watch: {
    params: {
      handler () {
        this.form.prjCode = this.params.prjCode
        this.form.prjCategoryCode = this.params.prjCategoryCode
        this.form.masterCategoryCode = this.params.masterCategoryCode
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      form: {
        prjCode: '',
        prjCategoryCode: '',
        masterCategoryCode: ''
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  },
  created () {
    this.query()
  }
}
</script>
